import { BoxStaffInvitationDetailsEntity } from "@modules/boxStaff/entities/boxStaffInvitationEntity"
import { useServicesContext } from "@modules/core/services/services.context"
import { useSuspenseQuery } from "@tanstack/react-query"

export const useBoxStaffInvitationDetails = (boxId?: string) => {
  const { boxStaffApi } = useServicesContext()

  const { data, isLoading } = useSuspenseQuery({
    queryKey: ["boxStaffInvitationDetails", { boxId }],
    queryFn: async () => {
      if (!boxId) {
        return null
      }
      return boxStaffApi.getBoxStaffInvitationDetails(boxId)
    },
  })

  return { data: data ? BoxStaffInvitationDetailsEntity.fromDto(data) : null, isLoading }
}
